import Api from '@/api'

const state = {
    items: [],
    pageNo: 0,
    pageSize: 10,
    totalCount: 0,
    totalPage: 0,
    users: [],
    uPageNo: 0,
    uPageSize: 10,
    uTotalCount: 0,
    uTotalPage: 0
}
const getters = {
    g_list: state => state.items,
    g_pageNo: state => state.pageNo,
    g_pageSize: state => state.pageSize,
    g_totalCount: state => state.totalCount,
    g_totalPage: state => state.totalPage,
    g_users: state => state.users,
    g_uPageNo: state => state.uPageNo,
    g_uPageSize: state => state.uPageSize,
    g_uTotalCount: state => state.uTotalCount,
    g_uTotalPage: state => state.uTotalPage
}
const mutations = {}
const actions = {
    async groupList({state}, params) {
        let {data} = await Api.groupList(params);
        let {pageNo, pageSize, items, totalPage, totalCount} = data;
        state.items = items;
        state.pageNo = pageNo;
        state.totalPage = totalPage;
        state.totalCount = totalCount;
    },
    async groupCreate({state}, params) {
        let {retCode, retMsg} = await Api.groupCreate(params);
        if (retCode == 0) {

        }
    },
    async groupTransfer({state}, params) {
        let {retCode, retMsg} = await Api.transferGroup(params);
        if (retCode == 0) {

        }
    },
    async groupDelUser({state}, params) {
        let {retCode, retMsg} = await Api.groupDelUser(params);
        if (retCode == 0) {

        }
    },
    async groupAddUser({state}, params) {
        let {retCode, retMsg} = await Api.groupAddUser(params);
        if (retCode == 0) {

        }
    },
    async groupDismiss({state}, params) {
        let {retCode, retMsg} = await Api.dismissGroup(params);
        if (retCode == 0) {

        }
    },
    async groupUsers({state}, params) {
        let {data} = await Api.groupUsers(params);
        let {pageNo, items, totalPage, totalCount} = data;
        state.users = items;
        state.uPageNo = pageNo;
        state.uPageSize = pageNo;
        state.uTotalCount = totalCount;
        state.uTotalPage = totalPage
    },
    async changeUserType({state}, params) {
        return await Api.changeUserType(params);
    },
    async modifyGroupInfo({state}, params) {
        return Api.modifyGroupInfo(params);
    }
}
export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/components/group_store.js